






import { Vue, Component, Prop, Ref, Emit } from 'vue-property-decorator'
import { State, Mutation, Getter } from 'vuex-class'

import TableOfContentToggleMenu from './TableOfContentToggleMenu.vue'

@Component
export default class TableOfContent extends Vue {
  private unwatchConsentLoading!: () => void

  @State(state => state.CONTENT.iframe) iframe!: boolean
  @State(state => state.CONTENT.idCounter) counter!: number
  @Mutation('CONTENT/INCREMENT_ID_COUNTER') incrementIdCounter!: () => void
  @Getter('CONTENT/areLoaded') areConsentsLoaded!: boolean

  @Prop({ default: '' }) readonly title!: string | null
  @Prop({ default: '' }) readonly target!: string
  @Prop({ default: 'element' }) readonly prefix!: string
  @Prop({ default: 2 }) readonly limit!: number

  @Ref('toc') readonly toc!: HTMLButtonElement

  @Emit() closeMenu () { return true }
  @Emit('has-build-menu') hasBuildMenu () { return true }

  load (): void {
    // Create query selector according to limit: ex 2 => h2,h3 / 3 => h2,h3,h4
    const query = [...Array(this.limit).keys()].map(i => `h${i + 2}`).join(',')
    const target = document.getElementById(this.target)

    if (target) {
      const matches = target.querySelectorAll(query)

      matches.forEach(node => {
        if (!node.id) node.id = this.prefix + this.counter
        const level = parseInt(node.tagName[1]) - 1
        const li = this.buildLi()

        if (level === 1) {
          // Handle main headers
          const a = this.buildAHeader(node.textContent || '', node.id)
          a.onclick = this.closeMenu
          li.appendChild(a)
          const ul = this.buildUl(level)
          ul.appendChild(li)
          this.toc.appendChild(ul)
        } else if (level < this.limit) {
          // Handle sub headers with submenu
          const a = this.buildAHeader(node.textContent || '', node.id)
          a.onclick = this.closeMenu
          li.appendChild(a)
          const parentUl = this.getParentUl(level)
          if (!parentUl.classList.contains(`header${level}`)) {
            parentUl.classList.add(`header${level}`)
          }
          parentUl.appendChild(li)
        } else {
          const parentUl = this.getParentUl(level)
          const a = this.buildA(node.textContent || '', node.id)
          a.onclick = this.closeMenu
          li.appendChild(a)
          parentUl.appendChild(li)
        }
        this.incrementIdCounter()
      })
      this.hasBuildMenu()
    }
  }

  buildUl (level: number): HTMLUListElement {
    const ul = document.createElement('ul')
    ul.classList.add('menu-list')
    ul.classList.add(`parent${level}`)
    if (level > 1) {
      ul.classList.add('sub-menu-list')
    }
    return ul
  }

  buildLi (): HTMLLIElement {
    const li = document.createElement('li')
    li.classList.add('sub-menu-list')
    return li
  }

  buildA (textContent: string, id: string): HTMLAnchorElement {
    const a = document.createElement('a')
    a.innerHTML = textContent
    a.href = `#${id}`
    return a
  }

  buildAHeader (textContent: string, id: string): HTMLElement {
    const MyComponent = Vue.extend(TableOfContentToggleMenu)
    const instance = new MyComponent({
      propsData: {
        header: textContent,
        anchor: `#${id}`,
        parent: this
      }
    })
    instance.$mount()
    const element: HTMLElement = instance.$el as HTMLElement
    return element
  }

  getParentUl (level: number): HTMLUListElement {
    const headerList = this.toc.querySelectorAll(`ul.parent${level - 1}`)
    const lastHeader = headerList[headerList.length - 1]
    const parentUl = lastHeader.querySelectorAll('.menu-list')[0] as HTMLUListElement
    return parentUl
  }

  created () {
    /* Will only fire this.load() once and then destroy the watcher */
    this.unwatchConsentLoading = this.$watch('areConsentsLoaded', (areLoaded) => {
      if (areLoaded) {
        this.load()
        this.unwatchConsentLoading()
      }
    })
  }
}
